module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": _vm.flat
    }
  }, [_c('v-card-title', {
    staticClass: "overline pb-0"
  }, [_vm._v("\n    Medical Aid details\n  ")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.value.name || 'scheme unknown'))]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text--primary"
  }, [_vm._v("\n          " + _vm._s(_vm.value.patient_first_name) + " " + _vm._s(_vm.value.patient_last_name) + "\n        ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("# " + _vm._s(_vm.value.number || 'no membership number'))])], 1)], 1), _vm._v(" "), (_vm.value.is_dependent === true) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Main member")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text--primary"
  }, [_vm._v(_vm._s(_vm.value.member_first_name) + " " + _vm._s(_vm.value.member_last_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          ID: " + _vm._s(_vm.value.main_member_id_number || 'unknown') + "\n        ")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27add4f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/MedicalAidCard.vue
// module id = 1650
// module chunks = 2